import { Injectable, inject } from '@angular/core';
import { DataService } from "../services/data.service";
import { Observable, of, switchMap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class Files {

  public src?: string;

  constructor(private dataService: DataService) {

  }

  public isImage(mimeType: string) {
    return mimeType.includes("image");
  }

  private getBlob(endpoint: string | undefined, id: number) {
    return new Observable<Blob>((observer) => {
      const url = id < 0 ? (endpoint + "") : (endpoint + "/download");
      this.dataService.downloadFile(url, Number(id)).subscribe(data => {
        const newBlob = new Blob([data.body as BlobPart], { type: data.body?.type });
        if (newBlob.type != "") {
          observer.next(newBlob);
        }
      });
    });
  }

  public getSrc(endpoint: string | undefined, id: number) {
    return this.getBlob(endpoint, id).pipe(switchMap(x => of(URL.createObjectURL(x))));
  }

  public preview(endpoint: string | undefined, id: number) {
    return this.getBlob(endpoint, id).subscribe(data => {
      window.open(URL.createObjectURL(data), '_blank');
    });
  }

  public download(endpoint: string | undefined, id: number, title: string) {
    return this.getBlob(endpoint, id).subscribe(data => {
      let a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.download = title;
      a.href = URL.createObjectURL(data);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    });
  }

  public downloadFile(response: any, filename: string): void {

    const { file: base64File } = response;

    const byteCharacters = atob(base64File);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);

  }





}

